import { Home } from "components/Home";
import { Main } from "components/pages";

export default function HomePage() {
  return (
    <>
      {/* <PageHeader title="Gerenciar Encomendas" /> */}

      <Main>
        <section>
          <Home />
        </section>
      </Main>
    </>
  );
}